export default {"src":"/_next/static/media/img_survey_X.c5f08bb9.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};